import { apiRequest } from "./api.client";
import { ApiError } from "./api.errors";

export interface GroupMemberClinic {
  clinic_id: string;
  name: string;
}

export interface ClinicGroup {
  clinic_group_id: string;
  owner_user_id: string;
  name: string;
  created_at: string;
  member_clinic_ids: string[];
  member_clinics: GroupMemberClinic[];
}

export const ClinicGroupAPI = {
  /** Returns null (not an error) when the caller doesn't own a group —
   * callers use this to decide whether to show the consolidated-view toggle
   * at all, not to render an error state. */
  async getMine(): Promise<ClinicGroup | null> {
    try {
      return await apiRequest<ClinicGroup>("/clinic-groups/mine");
    } catch (err) {
      if (err instanceof ApiError && err.isNotFound) return null;
      throw err;
    }
  },

  create: (name: string) =>
    apiRequest<ClinicGroup>("/clinic-groups", { method: "POST", body: JSON.stringify({ name }) }),

  get: (clinicGroupId: string) =>
    apiRequest<ClinicGroup>(`/clinic-groups/${clinicGroupId}`),

  attachOwnClinic: (clinicGroupId: string) =>
    apiRequest<ClinicGroup>(`/clinic-groups/${clinicGroupId}/clinics`, { method: "POST" }),
};

export default ClinicGroupAPI;
